<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Elektrogeräte (Küche)
            </h1>
            <p class="subTitle d-flex justify-center mb-4">
                <span style="text-decoration:underline; font-size:16px">(Mehrfachnennung möglich)</span>
            </p>
            <p class="subTitle">
                Hat Ihr*e Vermieter*in zusätzlich zur Grundausstattung (Spülmöglichkeit und Einbauschränke beziehungsweise Kücheninsel/Küchenblock) folgende Elektrogeräte zur Verfügung gestellt?
            </p>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="elektrogeraete">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span :aria-labelled-by="getErrorText(selectedData.errorTypes, selectedData.error, selectedData.id)" class="red--text" v-html="getErrorText(selectedData.errorTypes, selectedData.error, selectedData.id)"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group multiple role="list" tabindex="0" :aria-active-descendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="checkbox" tabindex="-1" :checked="isSelected(item.id)" :title="$t('elektrogeraete.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText()" v-html="getErrorText()"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-html="$t('elektrogeraete.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Elektrogeräte (Küche)</h3><br/>
                            <p>Zuschläge für die nachfolgenden Elektrogeräte dürfen nur vergeben werden, wenn die*der Vermieter*in 
                                als Grundausstattung eine Spülmöglichkeit und Einbauschränke zur Verfügung gestellt hat. Die 
                                Einbauschränke können auch in Form einer Kücheninsel/eines Küchenblocks zur Verfügung gestellt 
                                werden.</p>
                            <p><strong>Folgende Elektrogeräte können berücksichtigt werden:</strong><br>
                            Die Zuschläge a), b) und c) dürfen beim Vorliegen der Voraussetzungen nebeneinander angesetzt werden.<br>
                            <strong>a) Glaskeramik-Kochmulde (Ceranfeld) oder Induktionskochfeld</strong><br>
                            <strong>b) Kühlschrank oder Kühl-/Gefrierkombination</strong><br>
                            <strong>c) Geschirrspülmaschine</strong><br>
                            </p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { mapState, mapMutations, mapActions, createNamespacedHelpers } from 'vuex';

    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a elektrogeraete ERROR
        computed: { ...mapState('error', ['elektrogeraete']),
                    ...mapState('berechnung', ['localElektrogeraete']),
                    ...mapGetters(['hasPermission'])},
        methods: { ...mapActions('berechnung', ['SELECT_ELEKTROGERAETE']),
                   ...mapActions('error', ['CHECK_KUECHENGRUNDAUSSTATTUNG_ERROR']),
                   ...mapMutations('error', ['SET_ELEKTROGERAETE_ERROR']),
                    ...mapMutations('berechnung', ['UPDATE_LOCAL_ELEKTROGERAETE'])}
    })
    export default class Elektrogeraete extends Vue {

        get error(){
            return this.selectedData.some(item => this.hasError(item.error))
        }

        get selectedData(){
            return this.items.filter(item => this.selectedItem.includes(item.id))
        }

        get selectedItem() {
            return this.localElektrogeraete
        }

        set selectedItem(selection) {
            this.UPDATE_LOCAL_ELEKTROGERAETE({ selection: selection, none: this.noneOfThese })
        }

        data() {
            return {
                index: 12,
                noneOfThese: 3,
                items: [
                    { id: 0,
                      error: { selectedKuechengrundausstattung: function(el){ return el == 1 } } },
                    { divider: true},
                    { id: 1,
                      error: { selectedKuechengrundausstattung: function(el){ return el == 1 } } },
                    { divider: true},
                    { id: 2,
                      error: { selectedKuechengrundausstattung: function(el){ return el == 1 } } },
                    { divider: true},
                    { id: 3 },
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        checkForm() {
            this.validationError = false;
            if(this.selectedItem.length == 0) {
                this.validationError = true;
            }
            return !this.validationError;
        }

        isSelected(index) {
            if(this.selectedItem != null) {
                return this.selectedItem.includes(index);
            }
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(){
            //return errorText for error
            return this.$t('elektrogeraete.error');
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.multiItemSelection(event, vm))
        }

        multiItemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem.includes(id)){
                setTimeout(function(){
                    let selection = vm.selectedItem.slice()
                    selection.splice(selection.indexOf(id), 1)
                    vm.selectedItem = selection
                }, 100)
            }else{
                setTimeout(function(){
                    let selection = vm.selectedItem.slice()
                    selection.push(id)
                    vm.selectedItem = selection
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            if(this.checkForm()){
                console.log(this.selectedItem)
                this.SELECT_ELEKTROGERAETE({ selectedElektrogeraete: this.selectedItem,
                                              selectedElektrogeraeteError: this.selectedData
                                                                                .filter(it => it.error)
                                                                                .map(item => item.error) })
                this.CHECK_KUECHENGRUNDAUSSTATTUNG_ERROR()
                if(this.error){
                    console.log('found elektrogeraete error')
                    this.SET_ELEKTROGERAETE_ERROR(true)
                    let alert = document.querySelector('.errors')
                    alert.removeAttribute('role')
                    alert.setAttribute("role", "alert")
                } else {
                    this.SET_ELEKTROGERAETE_ERROR(false)
                    this.$router.push('fussboden')
                }
            }else{
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            }
        }

        back() {
            this.$router.push('kuechengrundausstattung')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }
    }
</script>
